import { Button, Input, Modal, Popconfirm, Spin, message } from "antd";
import { diffSentences } from "diff";
import { memo, useEffect, useRef, useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { connect } from "react-redux";
import Loading from "../../../../Components/Loading/Loading";
import Skill from "../../../../Components/Skill/Skill";
import Term from "../../../../Components/Term/Term";
import * as actions from "../../../../store/actions/action";
import styles from "../UserRoadmap.module.css";
import { findFlagRef } from "../UserRoadmap";

const ActionsRoadmap = ({
  LoadingSetter,
  loading,
  ClearLoading,
  roadmapId,
  globalSearch,
  terms,
  setTerms,
  skills,
  setSkills,
  skillsRef,
  flagsRef,
  isRoadmapChanged,
  setIsRoadmapChanged,
}) => {
  useEffect(() => {
    console.log({ skills });
  }, [skills]);

  const [editskillModal, setEditskillModal] = useState(null);
  const [newskillDescription, setNewskillDescription] = useState(null);
  const [updateForcer, setUpdateForcer] = useState(0);
  const endItemRef = useRef();

  const updateskillDescription = () => {
    if (!newskillDescription || newskillDescription === "") {
      return;
    }
    const newTerms = terms;
    const newskills = newTerms[editskillModal.termId].skills.map((skill) => {
      if (skill.id === editskillModal.id) {
        const newskill = skill;
        newskill.description = newskillDescription;
        return newskill;
      }
      return skill;
    });
    newTerms[editskillModal.termId].skills = newskills;
    setTerms(newTerms);
    setTimeout(() => {
      setUpdateForcer(updateForcer + 1);
    });
    setNewskillDescription(null);
    setIsRoadmapChanged(true);
  };
  const removeWayFromSkill = (termId, skillId, wayId) => {
    const newTerms = terms;
    const newskills = newTerms[termId].skills.map((skill) => {
      if (skill.id === skillId) {
        const newskill = skill;
        newskill.ways = newskill.ways
          .map((way) => {
            if (way.id === wayId) {
              return null;
            }
            return way;
          })
          .filter(function (el) {
            return el != null;
          });
        return newskill;
      }
      return skill;
    });
    newTerms[termId].skills = newskills;
    setTerms(newTerms);
    setTimeout(() => {
      setUpdateForcer(updateForcer + 1);
    });
    setIsRoadmapChanged(true);
  };
  const resetskill = () => {
    let skillRef = null;
    if (Array.isArray(skillsRef)) {
      skillsRef.forEach((el) => {
        if (el.id === editskillModal.id) {
          skillRef = el;
        }
      });
    }
    if (!skillRef) {
      return;
    }
    const newTerms = terms;
    const newskills = newTerms[editskillModal.termId].skills.map((skill) => {
      if (skill.id === editskillModal.id) {
        setEditskillModal(skillRef);
        return skillRef;
      }
      return skill;
    });
    newTerms[editskillModal.termId].skills = newskills;
    setTerms(newTerms);
    setEditskillModal(null);
  };

  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);
  useEffect(() => {
    if (isRoadmapChanged) {
      window.onbeforeunload = function (e) {
        return true;
      };
    } else {
      window.onbeforeunload = null;
    }
    return () => {
      window.onbeforeunload = null;
    };
  }, [isRoadmapChanged]);

  useEffect(() => {
    const endItem = endItemRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            console.log("End item is visible!");
            // Your event or function here
          }
        });
      },
      {
        root: null, // Use the viewport
        threshold: 0.05, // Trigger when 10% of the item is visible
      }
    );

    if (endItem) {
      observer.observe(endItem);
    }

    // Cleanup observer on component unmount
    return () => {
      if (endItem) {
        observer.unobserve(endItem);
      }
    };
  }, []);

  const onDragEnd = (result) => {
    const { destination, source, dragableId } = result;
    if (
      source.droppableId === "skills" &&
      destination.droppableId === "skills"
    ) {
    } else {
      setIsRoadmapChanged(true);
      const start = terms[source.droppableId];
      const end = terms[destination.droppableId];
      if (end) {
        if (end.skills.length === 8) {
          message.warning(".بیش از 8 کارت در یک بازه زمانی نمی‌توان داد");
          // return;
        }
      }
      if (source.droppableId === "skills") {
        const newTerms = terms;
        const newSkills = skills;
        newTerms[destination.droppableId].skills.splice(
          destination.index,
          0,
          skills[source.index]
        );
        newSkills.splice(skills.indexOf(skills[source.index]), 1);
        setTerms(newTerms);
        setSkills(newSkills);
      } else {
        if (start === end) {
          const newTermSkills = Array.from(start.skills);
          const [removed] = newTermSkills.splice(source.index, 1);
          newTermSkills.splice(destination.index, 0, removed);
          const newTerms = JSON.parse(JSON.stringify(terms));
          const newStart = { ...start, skills: newTermSkills };
          newTerms[source.droppableId] = newStart;
          // setTerms([]);
          setUpdateForcer(updateForcer + 1);
          setTimeout(() => {
            setTerms(newTerms);
          }, 1);
        }
        if (destination.droppableId === "skills") {
          const newTerms = terms;
          const newSkills = skills;
          const sourceFlag = start.skills[source.index];
          newSkills.push(sourceFlag);
          newTerms[source.droppableId].skills.splice(
            start.skills.indexOf(sourceFlag),
            1
          );
          setTerms(newTerms);
          setSkills(newSkills);
          setTimeout(() => {
            setUpdateForcer(updateForcer + 1);
          });
        } else {
          const newStart = start;
          const newEnd = end;
          const newTerms = terms;
          const sourceFlag = start.skills[source.index];
          newEnd.skills.splice(destination.index, 0, sourceFlag);
          newStart.skills.splice(start.skills.indexOf(sourceFlag), 1);
          newTerms[source.droppableId] = newStart;
          newTerms[destination.droppableId] = newEnd;
          setTerms(newTerms);
          setTimeout(() => {
            setUpdateForcer(updateForcer + 1);
          });
        }
      }
      setTimeout(() => {
        setUpdateForcer(updateForcer + 1);
      });
    }
  };

  return (
    <>
      <DragDropContext
        // onDragStart={}
        // onDragUpdate={}
        onDragEnd={onDragEnd}
      >
        <SkillsMenu
          loadingRef={endItemRef}
          skills={skills}
          globalSearch={globalSearch}
          roadmapId={roadmapId}
        />
        <div className={styles.Content}>
          {terms ? (
            Object.keys(terms).map((key, index) => {
              const term = terms[key];
              // console.log(term)
              return (
                <Term
                  key={key}
                  id={key}
                  isFetchedData={roadmapId ? true : false}
                  termTitle={term && term.title}
                >
                  {term.skills.map((el, index) => {
                    return (
                      <Skill
                        flag={
                          Array.isArray(el.flags) && el.flags.length > 0
                            ? findFlagRef(
                                {
                                  id:
                                    typeof el.flags[0] === "object" &&
                                    el.flags[0] !== null
                                      ? el.flags[0].id
                                      : el.flags[0],
                                },
                                flagsRef
                              )
                            : false
                        }
                        removeWayFromSkill={(wayId) => {
                          removeWayFromSkill(key, el.id, wayId);
                        }}
                        active={
                          `${el.description} | ${el.title}`.includes(
                            `${globalSearch}`
                          ) || `${globalSearch}`.trim() === ""
                        }
                        key={el.id}
                        index={index}
                        {...el}
                      />
                    );
                  })}
                </Term>
              );
            })
          ) : (
            <Loading />
          )}
        </div>
      </DragDropContext>

      {editskillModal && (
        <Modal
          title={editskillModal.title}
          open={editskillModal ? true : false}
          destroyOnClose
          footer={[
            <Popconfirm
              title="آیا از لغو تمامی تغییرات گذشته مطمئن هستید؟"
              onConfirm={() => {
                resetskill();
              }}
            >
              <Button danger type="text">
                بازگرداندن کارت به حالت اولیه
              </Button>
            </Popconfirm>,
            <Button
              onClick={() => {
                setEditskillModal(null);
                setNewskillDescription(null);
              }}
            >
              لغو
            </Button>,
            <Button
              onClick={() => {
                setEditskillModal(null);
                updateskillDescription();
              }}
              style={{ backgroundColor: "green", color: "white" }}
            >
              ذخیره
            </Button>,
          ]}
          onCancel={() => {
            setEditskillModal(null);
            setNewskillDescription(null);
          }}
          onOk={() => {
            setEditskillModal(null);
            updateskillDescription();
          }}
        >
          <Input.TextArea
            style={{ minHeight: "10rem" }}
            className={styles.ModalDescription}
            defaultValue={editskillModal.description}
            onBlur={(e) => {
              setNewskillDescription(e.target.value);
            }}
          />
          <DiffDescription skill={editskillModal} skillsRef={skillsRef} />
        </Modal>
      )}
    </>
  );
};
const findskillRef = (skill, skillsRef) => {
  let skillRef = null;
  if (Array.isArray(skillsRef)) {
    skillsRef.forEach((el) => {
      if (el.id === skill.id) {
        skillRef = el;
      }
    });
  }
  return skillRef;
};
const DiffDescription = memo(({ skill, skillsRef }) => {
  let skillRef = findskillRef(skill, skillsRef);
  let oldVal = "";
  let newVal = "";

  if (skillRef) {
    if (skillRef.description) {
      oldVal = skillRef.description;
    }
  }
  if (skill) {
    if (skill.description) {
      newVal = skill.description;
    }
  }
  // console.log(diffSentences(oldVal, newVal));
  return (
    <div className={styles.DiffDescription}>
      <h3>تغییرات</h3>
      <div className={styles.DiffText}>
        {diffSentences(oldVal, newVal).map((el) => {
          if (el.added) {
            return (
              <span>
                <span className={styles.AddedText}>
                  <div className={styles.PlusSign}>
                    {" "}
                    <span>+</span>{" "}
                  </div>
                  {el.value}
                </span>
              </span>
            );
          } else if (el.removed) {
            return (
              <span>
                <span className={styles.RemovedText}>
                  <div className={styles.MinusSign}>
                    {" "}
                    <span>-</span>{" "}
                  </div>{" "}
                  {el.value}
                </span>
              </span>
            );
          }
          return <span>{el.value}</span>;
        })}
      </div>
    </div>
  );
  //  <ReactDiffViewer
  //  oldValue={skillRef && skillRef.description}
  //  newValue={skill.description}
  //  splitView={false}
  //  hideLineNumbers
  //  showDiffOnly />
});
const SkillsMenu = ({ skills, roadmapId, globalSearch, loadingRef }) => {
  const [segment, setSegment] = useState("all");
  const [isPersonalSegement, setIsPersonalSegement] = useState(false);
  const [skillSearch, setSkillSearch] = useState("");
  return (
    <Droppable droppableId="skills">
      {(provided) => {
        return (
          <div className={styles.SkillsMenu}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <h1 className={styles.SkillsTitle}>مهارت ها</h1>
              <Input
                style={{ width: "60%" }}
                value={skillSearch}
                placeholder="جستجو ..."
                onChange={(e) => {
                  setSkillSearch(e.target.value);
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                paddingBottom: "1rem",
              }}
            ></div>
            <div
              className={styles.SkillsContainer}
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {Array.isArray(skills) && roadmapId ? (
                skills.map((el, index) => {
                  if (el.loading) {
                    return (
                      <div
                        ref={loadingRef}
                        style={{
                          backgroundColor: "red",
                          width: "100%",
                          padding: "2rem",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Spin />
                      </div>
                    );
                  }
                  let hide = false;
                  let isPersonal = false;
                  let isHidden = false;
                  if (el.personal) {
                    isPersonal = true;
                  }
                  if (el.hidden) {
                    isHidden = true;
                  }

                  if (
                    (segment === el.type ||
                      segment === "all" ||
                      (segment === "not_show" && isHidden)) &&
                    isPersonal === isPersonalSegement
                  ) {
                    hide = false;
                    if (el.title.includes(skillSearch)) {
                      hide = false;
                    } else {
                      hide = true;
                    }
                  } else {
                    hide = true;
                  }

                  return el ? (
                    <Skill
                      hide={hide}
                      {...el}
                      key={el.id}
                      index={index}
                      active={
                        `${el.description} | ${el.title}`.includes(
                          `${globalSearch}`
                        ) || `${globalSearch}`.trim() === ""
                      }
                    />
                  ) : null;
                })
              ) : (
                <Loading />
              )}
            </div>
            {provided.placeholder}
          </div>
        );
      }}
    </Droppable>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memo(ActionsRoadmap));
